var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 3.45082V2.24372L5.70895 3.09727L2.62186 6.18436C2.45101 6.35521 2.17399 6.35521 2.00314 6.18436C1.83229 6.01351 1.83229 5.73649 2.00314 5.56564L6.69064 0.878141L6.33744 0.524943L6.69064 0.878139C6.86149 0.707287 7.13851 0.707287 7.30936 0.878139L11.9968 5.56564L11.9968 5.56565C12.1677 5.7365 12.1677 6.0135 11.9968 6.18435C11.826 6.35521 11.549 6.35521 11.3782 6.18436L8.29105 3.09727L7.4375 2.24373V3.45082V11.8125C7.4375 12.0541 7.24162 12.25 7 12.25C6.75838 12.25 6.5625 12.0541 6.5625 11.8125V3.45082ZM1.25 16.1875C1.25 15.9459 1.44588 15.75 1.6875 15.75H12.3125C12.5541 15.75 12.75 15.9459 12.75 16.1875C12.75 16.4291 12.5541 16.625 12.3125 16.625H1.6875C1.44588 16.625 1.25 16.4291 1.25 16.1875Z",
    fill: "#24292E",
    stroke: "#FFC900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f9abd8871b4728357a2ce87d2ecbe43d.svg";
export { ForwardRef as ReactComponent };